import { combineReducers, createReducer, on } from "@ngrx/store";
import { contextPanelReducer } from "@store/doc-viewer/context-panel/context-panel.reducers";
import { panelReducer } from "@store/doc-viewer/panel/panel.reducers";
import { DocViewerState } from "@store/doc-viewer/doc-viewer.state";
import { actionPanelReducer } from "@store/doc-viewer/action-panel/action-panel.reducers";
import { documentViewReducers } from "@store/doc-viewer/document-view/document-view.reducers";
import { documentListReducer } from "@store/doc-viewer/document-list/document-list.reducers";
import { DocViewerActions } from "./doc-viewer.actions";
import { redactionEditorReducer } from "./redaction-editor/redaction-editor.reducer";
import { annotationEditorReducer } from "./annotation-editor/annotation-editor.reducer";

export const pdfPageReducers = createReducer<DocViewerState['pdfPage']>(
	1,
	on(DocViewerActions.pdfPageUpdate, (_state, {selectedPage}) => {
		return selectedPage;
	}),

);

export const docViewerReducer = combineReducers<DocViewerState>({
	panels: panelReducer,
	documentList: documentListReducer,
	currentContextPanelView: contextPanelReducer,
	currentActionPanelView: actionPanelReducer,
	currentDocumentView: documentViewReducers,
	pdfPage: pdfPageReducers,
	annotationEditor: annotationEditorReducer,
	redactionEditor: redactionEditorReducer
});
